import script from "./CouponManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponManagement.vue?vue&type=script&setup=true&lang=js"

import "./CouponManagement.vue?vue&type=style&index=0&id=3e4b59b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4b59b0"]])

export default __exports__